import React, { useCallback, useMemo } from 'react';
import { Heading, Text, Card, Row } from '../core';
import { StatusButton } from '../StatusButton';
import {
  useSend,
  useVaultPageSubgraph,
  fromNow,
  SCYVault,
  VaultUpgradable,
  IStratInfo,
} from '@sc1/common';
import type { CardProps } from 'theme-ui';

interface HarvestVaultProps extends CardProps {
  vault: VaultUpgradable | SCYVault | undefined;
  strategies: IStratInfo[];
  disabled: boolean;
}

export const HarvestVault = ({
  vault,
  disabled,
  strategies,
  ...rest
}: HarvestVaultProps): JSX.Element => {
  const { sendTx, txStatus } = useSend();

  const stratAddrs = useMemo(
    () => strategies?.map((x) => x.address),
    [strategies]
  );

  const harvestVault = useCallback(
    () => vault && strategies?.length && sendTx(vault, 'harvest', [stratAddrs]),
    [vault, sendTx, strategies]
  );

  const lastHarvest = useVaultPageSubgraph()?.data?.vault?.lastHarvest;

  return (
    <Card {...rest}>
      <Text variant="hint" mb={1}>
        Last Harvested {fromNow(Number(lastHarvest) * 1000)}
      </Text>
      <Heading mb={2} as="h3">
        Harvest All
      </Heading>
      <Row variant="collapse">
        <StatusButton
          disabled={disabled || !strategies?.length}
          onClick={harvestVault}
          status={txStatus}
        >
          Harvest
        </StatusButton>
      </Row>
      {/* {error && !strategies?.length && (
        <Text color="red">Error fetching strategies from subgraph</Text>
      )} */}
    </Card>
  );
};
